<template>
    <div class="h-full w-full flex flex-col pb-2">
        <InvoiceListActions v-model:selected-tab="selectedTab" class="h-fit"/>
        <div id="invoiceCreator" class="flex flex-col @[1500px]:flex-row w-full px-2 gap-2">
            <InvoiceList
                v-if="InvoiceDraftList.isEnabled && showInvoiceLists"
                v-model:selected-invoice="selectedInvoice"
                :invoice-tab="selectedTab"
                class="invoice-list flex-1 min-h-[40%]"
            />
            <div class="flex-1 dynamic-scrolling h-full">
                <invoice-creator v-if="selectedTab == INVOICE_TAB.DRAFT" class="" />
                <InvoiceView v-else-if="selectedInvoice" :invoice-uuid="selectedInvoice?.uuid" class="h-full"/>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import {ref} from 'vue'
import InvoiceList from '@/invoice/InvoiceCreator/InvoiceList.vue'
import InvoiceListActions from '@/invoice/InvoiceCreator/InvoiceListActions.vue'
import {INVOICE_TAB} from '@/invoice/types/InvoiceTab'
import InvoiceView from '@/invoice/InvoiceView.vue'
import {InvoiceBalance} from '@/invoice/InvoiceBalance'
import InvoiceCreator from '@/invoice/InvoiceCreator/InvoiceCreator.vue'
import {InvoiceDraftList} from '@/invoice/feature-toggles'
import {useEmitter} from '@/services/infrastructure/emitter'
import {SHOW_INVOICE_LISTS} from '@/types/invoice/InvoiceEvent'

const selectedTab = ref<INVOICE_TAB>(INVOICE_TAB.DRAFT)
const selectedInvoice = ref<InvoiceBalance>()

const {onEvent} = useEmitter()

const showInvoiceLists = ref(false)
onEvent(SHOW_INVOICE_LISTS, (showLists) => {showInvoiceLists.value = showLists as boolean})
</script>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";

#invoiceCreator {
    height: calc(100% - 44px);
}


</style>